//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_PET,
  ICON_COLOR_PET,
  FADE_BG_PET,
  FOOTER_BG_PET,
} from "../../utils/colors";

//IMPORT FONTS
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import BannerSection from "../../components/BannerSection";
import { PiShootingStar } from "react-icons/pi";
import FooterBar from "../../components/FooterBar";
import AllStars from "../../components/AllStars";
import EstrelinhasBG from "../../assets/images/estrelinhas-bg.jpg";
import "./Estrelinhas.css";

export default function Estrelinhas() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Estrelinhas">
      <DynamicTitle
        pageTitle="Grupo Krause - Estrelinhas"
        pageMeta="Estrelinhas"
        pageContent="Veja aqui todos os companheirinhos que viraram uma estrelinha no céu."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_PET}
        iconTitle={
          <PiShootingStar
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"ESTRELINHAS"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Veja aqui todos os companheirinhos que viraram uma estrelinha no céu."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={EstrelinhasBG}
        bannerBGmobile={EstrelinhasBG}
      />
      <AllStars
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <FooterBar titleColor={TITLE_COLOR_PET} footerBarBG={FOOTER_BG_PET} />
    </div>
  );
}
